import { css } from '@compiled/react';

import { wacToken } from '@/libraries/design/foundations';

export interface ListItemNumberProps {
	value: number;
}

export const ListItemNumber = (props: ListItemNumberProps) => {
	const { value } = props;
	return (
		<div
			css={css({
				flex: 'none',
				height: '48px',
				width: '48px',
				borderRadius: '100%',
				background: wacToken('color.extended.blue200'),
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				color: wacToken('color.extended.blue900'),
				textAlign: 'center',
				fontFamily: wacToken('font.charlie.display'),
				fontSize: '20px',
				fontStyle: 'normal',
				fontWeight: 700,
				lineHeight: '21px',
			})}
		>
			{value}
		</div>
	);
};
